import { Alert, Button, Group } from "@mantine/core";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableData, TableView } from "../../../custom-components/table";
import t from "../../../stores/language";
import theme from "../../../stores/theme";
import { useStyles } from "../configure-input";
import { failedReasonSummary, getAssetPreview } from "./insurance-data";
import { InsuranceUploadModal } from "./insurance-upload";

const restorationLabel = "Estimated Demolition / Disposal / Site Restoration %";

const InsurancePreview = () => {
  const { classes } = useStyles();
  const navigateTo = useNavigate();
  const [previewRows, setPreviewRows] = useState<TableData[]>(() => getAssetPreview());
  const [uploadOpen, setUploadOpen] = useState(false);
  const errorRecordCount = previewRows.filter((row) => row.reason !== "").length;
  const validRecordCount = previewRows.filter((row) => row.reason === "").length;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 142px)" }}>
      <div className={classes.reportsContainer} style={{ flex: 1, minHeight: 0, height: "auto", display: "flex", flexDirection: "column" }}>
        <div className={classes.title}>
          <span>{t("Insurance Data Preview")}</span>
        </div>
        <div style={{ flex: 1, minHeight: 0, position: "relative" }}>
          <TableView
            data={previewRows}
            columns={[
              { key: "assetId", label: "Asset ID", width: "12%" },
              { key: "assetName", label: "Asset Name", width: "18%" },
              { key: "codeType", label: "Code Type", width: "14%" },
              { key: "replacementCost", label: "Replacement Cost ($)", width: "16%", dataAlign: "right" },
              { key: "restorationPercent", label: restorationLabel, width: "22%", dataAlign: "right" },
              { key: "reason", label: "Failed Reason", width: "18%", color: "red" },
            ]}
            fixedLayout
            height="100%"
          />
          {previewRows.length === 0 ? (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
              }}
            >
              <Button style={{ pointerEvents: "auto" }} onClick={() => setUploadOpen(true)}>
                {t("Upload Sheet")}
              </Button>
            </div>
          ) : null}
        </div>
        {errorRecordCount > 0 ? (
          <Alert
            color="yellow"
            variant="light"
            mt={8}
            styles={{
              root: { padding: "4px 10px" },
              message: { fontSize: theme.fontSizes?.sm },
            }}
          >
            <b>{t("NOTE")}: </b>
            {`${t("Edit the file to make all records valid, then upload it again.")} (${failedReasonSummary(previewRows)})`}
          </Alert>
        ) : null}
      </div>
      {previewRows.length > 0 ? (
        <Group position="center" mt={10} style={{ flexShrink: 0 }}>
          <Button variant="default" onClick={() => setUploadOpen(true)}>
            {t("Upload again")}
          </Button>
          {validRecordCount > 0 ? <Button onClick={() => navigateTo("/insurance/estimates")}>{t("Calculate Estimates")}</Button> : null}
        </Group>
      ) : null}
      <InsuranceUploadModal
        opened={uploadOpen}
        onClose={() => setUploadOpen(false)}
        onUploaded={(rows) => {
          setPreviewRows(rows);
        }}
      />
    </div>
  );
};

export default InsurancePreview;
